/* eslint-disable no-unused-vars */
import { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FieldSelect } from 'components/form';
import { useInstitutions } from 'api/hooks';

export default function InstitutionFilter({ onChange, category, location, ...rest }) {
  const { institutions, isLoading } = useInstitutions({ locationCode: location });
  const [selectedValue, setSelectedValue] = useState();

  const filtered = useMemo(() => {
    if (_.isNil(category)) {
      return institutions;
    }
    return _.filter(institutions, (i) => i.category === category);
  }, [institutions, category]);
  const onSelect = useCallback(
    (option) => {
      setSelectedValue(option);
      onChange(option);
    },
    [onChange],
  );
  return (
    <FieldSelect
      value={selectedValue}
      onChange={(_value, option) => onSelect(option)}
      isLoading={isLoading}
      options={filtered ?? []}
      focusColor="indigo"
      searchable
      {...rest}
    />
  );
}

InstitutionFilter.propTypes = {
  onChange: PropTypes.func,
  location: PropTypes.any,
  category: PropTypes.any,
};
InstitutionFilter.defaultProps = {
  onChange: _.noop,
  location: null,
  category: null,
};
